var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon34BlogPaperplane2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 2 10 20H2L12 2m0-2a2 2 0 0 0-1.79 1.1l-10 20a2 2 0 0 0 1.8 2.9h20a2 2 0 0 0 1.78-2.9l-10-20A2 2 0 0 0 12 0z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 22.53V1.47"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0ibTEyIDIgMTAgMjBIMkwxMiAybTAtMmEyIDIgMCAwIDAtMS43OSAxLjFsLTEwIDIwYTIgMiAwIDAgMCAxLjggMi45aDIwYTIgMiAwIDAgMCAxLjc4LTIuOWwtMTAtMjBBMiAyIDAgMCAwIDEyIDB6IiBmaWxsPSIjMDAwIiAvPg0KICAgIDxwYXRoIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0xMiAyMi41M1YxLjQ3Ii8+DQogIDwvZz4NCjwvc3ZnPg0K";
export { SvgIcon34BlogPaperplane2 as ReactComponent };